import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: true,
  selector: 'dcc-reset-button',
  template: `
    <button
      class="lx-btn lx-btn-text"
      [disabled]="disabled"
      (click)="onClick()"
    >
      <i class="lx-icon lx-reset"></i>
      Reset
    </button>
  `,
  styles: ['button { min-width: auto; width: 80px; }'],
  styleUrls: ['../buttons.scss'],
})
export class ResetButtonComponent {
  @Input() disabled = false;

  @Output() reset: EventEmitter<void> = new EventEmitter();

  onClick() {
    this.reset.emit();
  }
}
